/**
 *
 * DialogContent
 *
 */

import React, { memo, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { StyledDialogContent } from './DialogContent.styles';

function DialogContent({ fixedActions, activeTab, ...props }) {
  const [showActionsBorder, setShowActionsBorder] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const { clientHeight } = contentRef?.current ?? {};
      const { scrollHeight } = contentRef?.current ?? {};
      const hasScroll = scrollHeight > clientHeight;
      setShowActionsBorder(hasScroll);
    }, [10]);

    return () => clearTimeout(timer);
  }, [activeTab, contentRef?.current]);

  const handleScroll = ({ target }) => {
    const isAtBottom =
      Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) <=
      1;
    setShowActionsBorder(!isAtBottom);
  };

  return (
    <StyledDialogContent
      $fixedActions={fixedActions}
      $actionsBorder={showActionsBorder}
      onScroll={handleScroll}
      ref={contentRef}
      {...props}
    />
  );
}

DialogContent.propTypes = {
  fixedActions: PropTypes.bool,
  activeTab: PropTypes.number,
};

export default memo(DialogContent);
